module.exports = __webpack_public_path__ + "img/ampel_pin_orange.5e8855bd.svg";